import React from 'react';

import ownerbg from "../../assets/images/ownerbg.jpg";

import { CgProfile } from "react-icons/cg";
import reviewsData from "../../assets/files/review.json";

const Timeline = () => {
    return (
        <>
            <div className="relative bg-no-repeat bg-cover  flex items-center justify-center py-10 px-3" style={{ backgroundImage: `url(${ownerbg})` }}>
                <div className="absolute inset-0 bg-black opacity-50"></div>
                <div className="panel">
                   
                   <h1 className='   text-center text-3xl  font-bold text-orange relative p-3'> What Our Clients Say</h1>
                   <p className='  text-white  text-xl relative text-justify sm:text-center p-3'>We have been very happy with our new website! It looks professional and is very easy to navigate. Our experience with the customer service at Thrive has been great.</p>
                    <div className="mb-5 inline-block w-full">
                        <ul className="relative py-12 before:absolute before:bg-[#ebedf2] dark:before:bg-[#191e3a] before:bottom-0 before:left-1/2 before:top-0 before:w-[3px] before:-ml-[1.5px] max-w-[900px] mx-auto table">
                            {reviewsData.map((review, index) => {
                                const isEven = index % 2 === 0;
                                return (
                                    <li key={index} className="relative mb-12 before:clear-both before:table after:clear-both after:table">
                                        <div className={`hidden sm:block absolute ${isEven ? 'bg-info' : 'bg-danger'} border-[3px] border-[#ebedf2] dark:border-[#191e3a] w-5 h-5 rounded-full left-1/2 top-[32px] -ml-2.5 z-[1] bg-orange`}></div>
                                        <div className={`before:hidden before:sm:block relative border border-[#ebedf2] dark:border-[#191e3a] max-w-[320px] mx-auto sm:max-w-full w-full sm:w-[46%] shadow-[0_20px_20px_rgba(126,142,177,0.12)] rounded-md bg-white dark:bg-[#191e3a] ${isEven ? 'sm:float-left before:right-[-37px] before:-translate-x-[px]' : 'sm:float-right before:-translate-x-[37px]'} before:absolute before:bg-[#ebedf2] dark:before:bg-[#191e3a] before:w-9 before:h-[3px] before:rounded-full before:top-10`}>
                                            <div className='flex justify-center pt-3'>
                                                {/* <img src={client1} alt='image' className="w-[100px] h-[100px] rounded-full object-cover border-orange border-2" /> */}
                                            </div>
                                            <div className="p-3 flex flex-col justify-center items-center">
                                                <h4 className="mb-3 text-info text-lg font-semibold">{review.name}</h4>
                                                <p className="mb-3 text-white-dark text-justify text-[#a3a3a3]">
                                                    {review.content}
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Timeline;
